<template>
  <v-menu
    :close-on-content-click="false"
    v-model="isOpen"
    lazy
    transition="slide-y-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <text-field
      class="hf"
      :value="formattedDate"
      :label="this.label"
      :optional="this.optional"
      :errors="this.errors"
      ref="textfield"
      slot="activator"
    >
      <v-icon :slot="getIconLeftOrRight()">event</v-icon>
    </text-field>

    <div>
      <v-date-picker
        @input="isOpen = false"
        v-model="_value"
        locale="nl-nl"
        ref="DatePicker"
        :min="this.min"
        :max="this.max"
        :event-color="this.eventColor"
        :events="this.events"
      />
      <p
        class="datepicker-clear"
        v-if="this.clearable && this.value != null"
        @click="this.handleClear"
      >
        <v-icon size="17" color="#fff" class="mr-1" style="position: relative; top: -1px">delete</v-icon>Datum Leegmaken
      </p>
    </div>
  </v-menu>
</template>

<script>
import Helpers from "../../utils/helpers/functions";
import TextField from "../../0_atoms/input/TextField.vue";

export default {
  name: "DatePicker",
  props: {
    label: String,
    optional: Boolean,
    value: String,
    left: Boolean,
    right: Boolean,
    errors: null,
    max: null,
    min: null,
    eventColor: String,
    events: null,
    clearable: Boolean
  },
  components: {
    TextField
  },

  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    getIconLeftOrRight() {
      if (this.left) return "left";
      if (this.right) return "right";
      return "left";
    },
    handleClear() {
      this._value = null;
      this.isOpen = false;
    }
  },
  computed: {
    formattedDate() {
      return Helpers.Dates.formatDate(this.value);
    },

    _value: {
      set(v) {
        this.$emit("input", v);
      },
      get() {
        return this.value;
      }
    }
  }
};
</script>
